export const COUNT_NULL_KEYS = [
    'orion.countWithNull',
    'ac_count_with_null',
    'unique_count_with_null',
];
export const VIRTUAL_COUNT_NULL = 'enableCountWithNull_Virtual';
export const DATE_BUCKET_KEY = 'ac_default_bucket_for_date';
export const DATE_BUCKET_BACKEND_DEFAULT = '-1';
export const DEBOUNCE_DELAY = 1000;
//# sourceMappingURL=constants.js.map